import { render, staticRenderFns } from "./RespostaCadastro.vue?vue&type=template&id=3e1bacba"
import script from "./RespostaCadastro.vue?vue&type=script&lang=js"
export * from "./RespostaCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports